module.exports = __webpack_public_path__ + "static/img/iconalipay.5570850.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconalipay.jpg
// module id = +Uki
// module chunks = 1